var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "6",
      "sm": ""
    }
  }, [_c('v-btn', _vm._b({
    staticClass: "border",
    attrs: {
      "block": ""
    },
    on: {
      "click": _vm.toggleAudio
    }
  }, 'v-btn', {
    loading: _vm.loading
  }, false), [_vm.enabled_audio ? [_c('v-icon', {
    staticClass: "mr-8"
  }, [_vm._v(" mdi-microphone-off ")]), _c('span', [_vm._v(" 마이크 끄기 ")])] : [_c('v-icon', {
    staticClass: "mr-8"
  }, [_vm._v(" mdi-microphone ")]), _c('span', [_vm._v(" 마이크 켜기 ")])]], 2)], 1), _c('v-col', {
    attrs: {
      "cols": "6",
      "sm": ""
    }
  }, [_c('v-btn', _vm._b({
    staticClass: "border",
    attrs: {
      "block": ""
    },
    on: {
      "click": _vm.toggleMuted
    }
  }, 'v-btn', {
    loading: _vm.loading
  }, false), [_vm.enabled_muted ? [_c('v-icon', {
    staticClass: "mr-8"
  }, [_vm._v(" mdi-volume-high ")]), _c('span', [_vm._v(" 음소거 끄기 ")])] : [_c('v-icon', {
    staticClass: "mr-8"
  }, [_vm._v(" mdi-volume-off ")]), _c('span', [_vm._v(" 음소거 켜기 ")])]], 2)], 1), _c('v-col', {
    attrs: {
      "cols": "6",
      "sm": ""
    }
  }, [_c('v-btn', _vm._b({
    staticClass: "border",
    attrs: {
      "block": ""
    },
    on: {
      "click": _vm.toggleVideo
    }
  }, 'v-btn', {
    loading: _vm.loading
  }, false), [_vm.enabled_video ? [_c('v-icon', {
    staticClass: "mr-8"
  }, [_vm._v(" mdi-camera-off ")]), _c('span', [_vm._v(" 화면 끄기 ")])] : [_c('v-icon', {
    staticClass: "mr-8"
  }, [_vm._v(" mdi-camera ")]), _c('span', [_vm._v(" 화면 켜기 ")])]], 2)], 1), _c('v-col', {
    attrs: {
      "cols": "6",
      "sm": ""
    }
  }, [_c('v-btn', _vm._b({
    attrs: {
      "block": "",
      "color": "red",
      "dark": ""
    },
    on: {
      "click": _vm.exit
    }
  }, 'v-btn', {
    loading: _vm.loading
  }, false), [_c('v-icon', {
    staticClass: "mr-8"
  }, [_vm._v(" mdi-logout-variant ")]), _c('span', [_vm._v(" 나가기 ")])], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }